import React from "react";
import { SectionLabelComponent } from "./SectionLabel/SectionLabel";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import EditPencil from "../../icons/EditPencil";
import useButtonPosition from "../../../hooks/useButtonPosition";
import { useShelvingStore } from "../../../store/useShelvingStore";
import shallow from "zustand/shallow";
import { useStoreSystem } from "../../../store";

interface SectionButtonsProps {
    camera: any;
    canvasSize: any;
    location: string;
}

export const SectionButtons: React.FunctionComponent<SectionButtonsProps> = ({ canvasSize, camera, location }): any => {
    const calcPosition = useButtonPosition('bottom');
    //TODO нет смысл каждый фрейм брать текущий стеллаж, надо вынести.
    const { getCurrentShelf, shelving } = useShelvingStore(state => ({
        getCurrentShelf: state.getCurrentShelving,
        shelving: state.shelving,
    }), shallow);
    const { currentSectionId } = useStoreSystem(state => ({
        currentSectionId: state.currentSectionId,
    }));
    const sections = getCurrentShelf().sections;

    if (camera && canvasSize) {
        if (location === "sections") {
            return sections.map(section =>
                <SectionLabelComponent
                    value={<EditPencil isChecked={true} />}
                    key={`${section.offset}`}
                    pos={calcPosition(section, null)}
                    camera={camera}
                    id={section.id}
                    canvasSize={canvasSize}
                    type={section.isIndent ? "indent" : "edit"}
                    section={section}
                />
            )
        }

        if (location === "items") {
            const filterSections = sections.filter(section => section.isIndent === false);
            return filterSections.map(section =>
                <SectionLabelComponent
                    id={section.id}
                    value={<AddRoundedIcon />}
                    key={`${section.offset}`}
                    pos={calcPosition(section, null)}
                    camera={camera}
                    canvasSize={canvasSize}
                    type={"button"}
                    section={section}
                />)
        }
    }
    return null;
}
